import BookACallButton from '../Buttons/Specials/BookACallButton'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

export default function NeedHelp() {
    const profiles = [
        {
            img: '/assets/get-started/jake.webp',
            name: 'Jake Soper',
        },
        {
            img: '/assets/get-started/jenn.webp',
            name: 'Jenn Brown',
        },
        {
            img: '/assets/get-started/adrian.webp',
            name: 'Adrian',
        },
        // {
        //     img: '/assets/homepage/John.png',
        //     name: 'John',
        // },
    ]
    return (
        <div className="max-w-full w-[1200px] mx-auto my-16">
            <div className="bg-olm-gradient-diagonal-75 shadow-[0_16px_12px_rgba(0,0,0,0.04)] px-6 py-12 md:py-8 md:px-12 rounded-2xl m-4">
                <div className="flex lg:flex-row flex-col lg:space-y-0 space-y-8">
                    <div className="lg:w-1/3 lg:space-y-8">
                        <h3 className="lg:block hidden text-5xl/[1.15] font-bold text-white">
                            Need some help from the pros?
                        </h3>
                        <h3 className="lg:hidden block text-4xl/[1.15] font-bold text-center text-white">
                            Meet Your Coaches
                        </h3>
                        <div className="w-72 hidden lg:block">
                            <BookACallButton
                                scheme="white"
                                Modal={HomepageBookCallLeadModal}
                            />
                        </div>
                    </div>
                    <div className="lg:w-2/3 flex md:flex-row flex-col items-center md:space-x-8 md:space-y-0 space-y-8">
                        {profiles.map((profile, i) => (
                            <div className="md:w-full w-2/3 space-y-4" key={i}>
                                <img
                                    src={profile.img}
                                    alt={profile.name}
                                    className="w-36 h-36 rounded-full mx-auto bg-white"
                                />
                                <p className="text-2xl/[1.15] font-bold text-white text-center">
                                    {profile.name}
                                </p>
                            </div>
                        ))}
                    </div>
                    <div className="lg:hidden text-center">
                        <BookACallButton
                            scheme="white"
                            Modal={HomepageBookCallLeadModal}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
